export const SchoolDetail=()=>{
  return(
    <>
      <div>SchoolDetail</div>
    </>
  )
}